module.exports = "<app-accountmaster-menu></app-accountmaster-menu>\n<p>\n  deposit-renewal works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/deposit-renewal/deposit-renewal.component.html
// module id = ./src/app/accountmaster/deposit-renewal/deposit-renewal.component.html
// module chunks = main